import { saveAs } from "file-saver";
import { put } from "redux-saga/effects";

import { fileApiFetch } from "common/utilities";
import { RequestError } from "common/utilities/requestError";
import { activateModal } from "domains/modal/actions";
import { fetchTopicPresentationFulfilled, fetchTopicPresentationRejected } from "domains/topic/actions";
import type { FetchTopicPresentationAction } from "domains/topic/actionTypes";

export function* fetchTopicPresentationSaga(action: FetchTopicPresentationAction) {
  try {
    const topicPresentation: Blob = yield fileApiFetch(`topic/${action.payload.id}/presentation`, {
      headers: { Accept: "application/vnd.openxmlformats-officedocument.presentationml.presentation" },
    });
    saveAs(topicPresentation, `Dynamic briefing - ${action.payload.name}.pptx`);
    yield put(fetchTopicPresentationFulfilled());
  } catch (error) {
    yield put(fetchTopicPresentationRejected({ logoutOnAuthError: true }));
    if (error instanceof RequestError && error.status !== 401) yield put(activateModal({ id: "Error" }));
  }
}
